
import * as util from './util';
import {dateToStr} from "./util";


/**
 * datepickerInit
 */
export const datepickerInit = (dayResult, pickerName = '#datepicker', periodDay = null, formatDate = 'yyyy-mm-dd') => {
  const from = dayResult.start_period;
  const to = dayResult.end_period;
  const startDate = `${from.substring(0, 4)}-${from.substring(4, 6)}-${from.substring(6, 8)}`;
  const endDate = `${to.substring(0, 4)}-${to.substring(4, 6)}-${to.substring(6, 8)}`;

  if(periodDay){
    let limitStartDate = moment(endDate).subtract(periodDay, 'days').format("YYYY-MM-dd");
    setDatePicker(pickerName, limitStartDate, endDate, formatDate);
    return;
  }
  setDatePicker(pickerName, startDate, endDate, formatDate);
};


const setDatePicker = (pickerName, startDate, endDate, formatDate) => {
  $(pickerName).datepicker({
    rtl: KTUtil.isRTL(),
    autoclose: true,
    format: formatDate,
    todayHighlight: true,
    orientation: 'bottom left',
    startDate,
    endDate,
    templates: util.arrowsInit(),
  }).val(endDate);
  if (pickerName === '#datepicker') {
    $('#datepicker').val(endDate);
  }
};
/**
 * monthpicker arrowsInit
 */
export const monthpickerInit = (monthResult, element, periodMonth = null) => {
  if (element == null) element = $('#monthpicker, .monthpicker');
  let monthResultLatest;
  let startMonth;


  if (periodMonth) {
    let tmpMonth = new Date();

    let convertMonthResult = monthResult.map(x => new Date(`${x.billing_period.substring(0, 4)}-${x.billing_period.substring(4, 6)}`));
    monthResultLatest = convertMonthResult.sort((a, b) => b.date - a.date)[0];

    tmpMonth.setMonth(monthResultLatest.getMonth() - (periodMonth - 1));
    startMonth = dateToStr(tmpMonth).substring(0, 7).replace(/-/g, '');

    let filter = monthResult.filter(x => x.billing_period >= startMonth);

    drawMonthPicker(filter, element);
    return;
  }

  drawMonthPicker(monthResult, element);
};

const drawMonthPicker = (data, element) => {
  data.forEach((item) => {

    const yearMonth = item.billing_period;
    const formattedYearMonth = `${yearMonth.substring(0, 4)}-${yearMonth.substring(4, 6)}`;
    element.append(`<option value="${yearMonth}">${formattedYearMonth}</option>`);
  });
  element.selectpicker('refresh');
};


/**
 * 원천 데이터 불러오기 공통화
 * @param {*} keyCorpId accountId가 all일때 corpId값
 * @param {*} keyAccountId account가 all이면 param에 corpId추가 아니면 accountId추가
 * @param {*} keyApi api구분
 * @param {*} keyTapState monthly daily구분
 * @param {*} callback api 호출 후 받은 데이터 callback
 */
export const initDataInfo = async (keyCorpId, keyAccountId, keyApi, keyTapState, callback, keyType, params) => {
  if(params == null) params = {};
  let url;
  if (keyTapState === 'monthly') {
    const yyyymm = $('#monthpicker').val();
    if(yyyymm){
      params.yyyymm = yyyymm;
    }
  } else {
    const date = $('#datepicker').val();
    if(date){
      const yyyymmdd = date.substring(0, 4) + date.substring(5, 7) + date.substring(8, 10);
      params.yyyymmdd = yyyymmdd;
    }
  }

  // costType 구분
  const userAuth = $('meta[name="userAuth"]').attr('content')

  /* url 및 날짜 인자(yyyymm 또는 yyyymmdd) 설정 */
  if(userAuth == 'UA') {
    if (keyType != null) {
      if (keyTapState === 'monthly') {
        url = keyApi['account'].month[keyType];  // keyApi['corp'].month.keyType
        params.yyyymm = $(`#monthpicker-${keyType}`).val();
      } else {
        url = keyApi['account'].day[keyType];
        const date = $(`#datepicker-${keyType}`).val();
        if(date){
          const yyyymmdd = date.substring(0, 4) + date.substring(5, 7) + date.substring(8, 10);
          params.yyyymmdd = yyyymmdd;
        }
      }
    } else {
      url = keyApi.account;
    }
  } else {
    if (keyType != null) {
      if (keyTapState === 'monthly') {
        url = keyApi[keyAccountId === 'all' ? 'corp' : 'account'].month[keyType];
        params.yyyymm = $(`#monthpicker-${keyType}`).val();
      } else {
        url = keyApi[keyAccountId === 'all' ? 'corp' : 'account'].day[keyType];
        const date = $(`#datepicker-${keyType}`).val();
        if(date){
          const yyyymmdd = date.substring(0, 4) + date.substring(5, 7) + date.substring(8, 10);
          params.yyyymmdd = yyyymmdd;
        }
      }
    } else {
      url = keyAccountId === 'all' ? keyApi.corp : keyApi.account;
    }
  }

  /* corpId 또는 accountId 설정 */
  if(userAuth == 'UA') {
    if(keyAccountId != 'all') {
      params.accountId = keyAccountId;
    }
  } else {
    if (keyAccountId === 'all') {
      params.corpId = keyCorpId;
    } else {
      params.accountId = keyAccountId;
    }
  }

  await util.customFetch(url, (data) => {
    callback(data);
  }, params);
};

/**
 *
 * @param {*} callback keyAccountId callback
 */
export const initAccount = async (callback) => {
  const AccountIds = await util.getAccountList();
  const isCompany = $('meta[name="costType"]').attr('content') === 'company';
  const accountPicker = $('#accountpicker-month, #accountpicker-day');
  let keyAccountId = '';

  if(AccountIds.length !== 0){
    keyAccountId = AccountIds[0].account_id;
  }

  // costType이 company인 경우 All Accounts 선택 가능
  if (isCompany) {
    keyAccountId = 'all';
    accountPicker.append('<option data-subtext="company" value="all">All Accounts</option>');
    accountPicker.append('<option data-divider="true"></option>');
  }

  $.each(AccountIds, (key, value) => {
    const accountId = value.account_id;
    const accountName = value.account_name;
    accountPicker.append(`<option data-subtext="${accountName}">${accountId}</option>`);
  });
  callback(keyAccountId);
};

/**
 *
 * @param {*} keyTapState daily|monthly 구분
 * @param {*} mainData filter할 데이터
 * @param {*} firstTableInit 이동할 테이블함수명
 * @param {*} usageFee summary데이터함수명
 * @param {*} filterCondition servicefilter사용시 기준 field명
 */
export const changeApply = (keyTapState, mainData, firstTableInit, usageFee, filterCondition = 'servicecode') => {
  const servicepicker = keyTapState === 'monthly' ? $('#servicepicker-month') : $('#servicepicker-day');
  const regionpicker = keyTapState === 'monthly' ? $('#regionpicker-month') : $('#regionpicker-day');
  const billingEntitypicker = keyTapState === 'monthly' ? $('#billingEntitypicker-month') : $('#billingEntitypicker-day');

  const region = regionpicker.selectpicker('val');

  const billingEntity = billingEntitypicker.selectpicker('val');

  const filteredDataRegion = util.dataFilter(mainData, ['product_region', 'product_region_name'], region);

  let returnFilteredData = [];

  if (servicepicker.length !== 0) {
    const service = servicepicker.selectpicker('val');
    let filteredDataService = util.dataFilter(filteredDataRegion, [filterCondition], service);

    filteredDataService = billingEntity ? util.dataFilter(filteredDataService, ['billing_entity'], billingEntity) : filteredDataService;

    returnFilteredData = filteredDataService;
  } else {
    returnFilteredData = filteredDataRegion;
  }


  $(`#kt_datatable_${keyTapState}`).KTDatatable('destroy');
  util.eventsCapture();
  firstTableInit(returnFilteredData);
  usageFee(returnFilteredData, keyTapState);
};
